<template>
  <div class="panel-organization-configuration-search flex flex-col gap-4">
    <panel-organization-configuration-item title="Recherche Typesense">
      <div class="panel-organization-configuration-search__content flex flex-col gap-4">
        <BcButton @click="generateTypesenseCredentials" :disabled="isTypesenseCredentialsGenerated">Générer les identifiants Typesense</BcButton>
        <BcButton @click="generateTypesenseCredentials" :disabled="!isTypesenseCredentialsGenerated">Re-générer les identifiants Typesense</BcButton>
        <BcButton @click="syncTypesenseCoders" :disabled="!isTypesenseCredentialsGenerated">Synchroniser les coders Typesense</BcButton>
      </div>
    </panel-organization-configuration-item>
    <panel-organization-configuration-item title="Recherche Algolia">
      <div class="panel-organization-configuration-search__content flex flex-col gap-4">
        <BcButton :disabled="isAlgoliaCredentialsGenerated" @click="generateTypesenseCredentials">Générer les identifiants Algolia</BcButton>
        <BcButton :disabled="!isAlgoliaCredentialsGenerated" @click="generateTypesenseCredentials">Re-générer les identifiants Algolia</BcButton>
        <BcButton :disabled="!isAlgoliaCredentialsGenerated" @click="syncTypesenseCoders">Synchroniser les coders Algolia</BcButton>
      </div>
    </panel-organization-configuration-item>
  </div>
</template>

<script setup lang="ts">
import PanelOrganizationConfigurationItem from './PanelOrganizationConfigurationItem.vue';
import BcButton from '@/ui-kit/components/BcButton/BcButton.vue';
import { generateTypesenseCredentials as generateTypesenseCredentialsApi, syncTypesenseCoders as syncTypesenseCodersApi } from '@/api/organizations';
import { useToast } from '@/ui-kit/components/BcToast';
import { ref } from 'vue';
const props = defineProps({
  profile: {
    type: Object,
    required: true,
  },
});

const toast = useToast();
const isTypesenseCredentialsGenerated = ref(props.profile.configuration.integrations.typesense?.credentials?.appKey || false);
const isAlgoliaCredentialsGenerated = ref(props.profile.configuration.integrations.algolia?.credentials?.appKey || false);

async function syncTypesenseCoders() {
  try {
    await syncTypesenseCodersApi(props.profile._id);
    toast.show({
      type: 'info',
      message: 'Synchronisation en cours',
    });
  } catch (err) {
    toast.show({
      type: 'error',
      message: err?.message,
    });
  }
}

async function generateTypesenseCredentials() {
  try {
    await generateTypesenseCredentialsApi(props.profile._id);
    isTypesenseCredentialsGenerated.value = true;
    toast.show({
      type: 'success',
      message: 'Génération des identifiants Typesense réussie',
    });
  } catch (err) {
    toast.show({
      type: 'error',
      message: err?.message,
    });
  }
}

</script>

<style lang="scss" scoped>
.panel-organization-configuration-features {
  &__content {
    flex-direction: column;
    width: 100%;
    gap: 16px;
  }

  &__item {
    width: 100%;
    justify-content: space-between;
  }
}
</style>
